import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";

export const RollbackDialog = ({open, handleClose, eventIds, handleRollback}) => {
    return (
        <Dialog open={open} onClose={handleClose} closeAfterTransition={false}>
            <DialogTitle id="drop-player-dialog">
                Rollback records?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {eventIds.join(', ')}
                </DialogContentText>
                <Button variant="outlined" type="submit" color="primary" style={{margin: 20}}
                        onClick={handleClose}>Cancel</Button>
                <Button variant="contained" type="submit" color="primary" style={{margin: 20}}
                        onClick={handleRollback}>Rollback</Button>
            </DialogContent>
        </Dialog>
    );
}